import React, { useState } from 'react';
import {isMobile} from 'react-device-detect';
import { Space, Layout, Typography } from 'antd';
import { Row, Col } from 'antd';
import { Button } from 'antd';
import HeaderTitle from '../Components/HeaderTitle'
import ProgressBar from '../Components/ProgressBar'
import AlertBar from '../Components/Alert'
import NextButton from '../Components/NextButton'
import PrevButton from '../Components/PreviousButton'
import ProductInfo from './ProductInfo'
import ServiceInfo from './ServiceInfo'
import CustomerInfo from './CustomerInfo'
import PaymentInfo from './PaymentInfo'
import Summary from './Summary'
import AgreeMent from './AgreeMent'
import ResultForm from './ResultForm'

function OrderForm() {
  // console.log(process.env.NODE_ENV)
  const { Header, Footer, Sider, Content } = Layout;
  const { Title, Paragraph, Text, Link } = Typography;
  const [step, setStep] = useState(0);
  const [formData, setFormData] = useState({
    products: [],
    productsDetail: [],
    tvBoxQty: 0,
    ipPhoneQty: 0,
    ipPhonePortIn: 1,
    ipPhonePortInNumber: "",
    ipPhoneAddressOption: 1,
    ipPhoneAddress: "",
    installationTime: 1,
    dateRequest: "",
    firstName: "",
    middleName: "",
    lastName: "",
    contactPhone: "",
    altPhone: "",
    email: "",
    installationAddress: "",
    city: "",
    province: "",
    postalCode: "",
    optionsUnitType: 1,
    buzz: "",
    optionsSameAddress: 1,
    billingAddress: "",
    optionsCardType: 1,
    cardFirstName: "",
    cardLastName: "",
    cardNumber: "",
    mm: "",
    yy: "",
    cvv: "",
    firstInitialPayment: "",
    recurrentPayment: "",
    cardRegistrationAddress: "",
    checkAgreeMent: false,
    promoteCode: "",
    additionalRequirements: "",
    productAs: [],
    productBs: [],
    productCs: [],
    productDs: [],
    tvBoxQtySelected: 0,
    ipPhoneQtySelected: 0,
  });

  const FormTitles = ["Choose Product", "Service Time", "Customer Info", "Payment Info", "Review"];

  const NextButtonClick = () => {
    return <NextButton step={step} setStep={setStep} FormTitles={FormTitles} formData={formData} setFormData={setFormData} />;
  };

  const PrevButtonClick = () => {
    return <PrevButton step={step} setStep={setStep} FormTitles={FormTitles} />;
  };

  const PageDisplay = () => {
    if (step === 0) {
      return <ProductInfo formData={formData} setFormData={setFormData} />;
    } else if (step === 1) {
      return <ServiceInfo formData={formData} setFormData={setFormData} />;
    } else if (step === 2) {
      return <CustomerInfo formData={formData} setFormData={setFormData} />;
    } else if (step === 3) {
      return <PaymentInfo formData={formData} setFormData={setFormData} />;
    } else if (step === 4) {
      return (
        <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
          <Summary formData={formData} setFormData={setFormData} />
          <AgreeMent formData={formData} setFormData={setFormData} />
        </Space>
      )
    } else if (step === 5) {
      return <Submit formData={formData} setFormData={setFormData} />;
    }
  };

  const HeaderTitleDisplay = () => {
    return <HeaderTitle step={step} FormTitles={FormTitles} />;
  };

  const ProgressDisplay = () => {
    return <ProgressBar progress={step} FormTitles={FormTitles} />;
  };

  const AlertDisplay = () => {
    return <AlertBar />;
  };

  return (
    <>
      <Layout style={{ minHeight: "100vh", backgroundColor:"#ffffff", }}>
        <Header style={{ backgroundColor: "#90BA75", position: 'fixed', zIndex: 1, width: '100%', }}>
          { HeaderTitleDisplay() }
        </Header>
        <Space direction="vertical" size="large" style={{ display: 'flex', }}>
          <Content style={
            isMobile ? {
               padding: '0 15px', marginTop: 64
            } : {
               padding: '0 17.5%', marginTop: 64
            }
          }>
            {
              // AlertDisplay()
            }
            { PageDisplay() }
          </Content>
          <div />
          <Content>
            <Row justify="space-evenly center">
              <Col span={2}></Col>
              <Col span={6}>{ PrevButtonClick() }</Col>
              <Col span={6}>{ NextButtonClick() }</Col>
              <Col span={2}></Col>
            </Row>
          </Content>
        </Space>
        <Footer style={{ textAlign: 'center', backgroundColor:"#ffffff" }}>
          {!isMobile ? ('©2022 Geneva Systems Ltd.') : null}
        </Footer>
      </Layout>
    </>

  );
}


export default OrderForm;
